angular
    .module('WizApp')
    .service('CookiesConsentService', [
        '$q',
        '$http',
        '$filter',
        function ($q, $http, $filter) {
            var route = $filter('route');

            return {
                setCookiesConsent: function (cookiesData) {
                    var url = route('wizbii_consent_create');
                    return $http.post(url, cookiesData, {
                        transformRequest: data => {
                            return JSON.stringify(data);
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }).then(() => {
                        localStorage.removeItem('cookie_banner_shown');
                    });
                },

                getCookiesConsent() {
                    return $q(function (resolve, reject) {
                        let url = route('wizbii_consent_get');

                        $http
                            .get(url)
                            .success((consentData) => {
                                resolve(consentData);
                            })
                            .error(() => {
                                reject({ status: 'error' });
                            })
                        ;
                    });
                }
            };
        }
    ])
;
